import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HighlightCard from "../../ui/components/HighlightCard";
import PillButton from "../../ui/components/PillButton";
import sortingErrorIcon from "../../static/assets/dashboard-sorting-error.svg";
import sortingPreviousIcon from "../../static/assets/dashboard-sorting-previous.svg";
import sortingVariationIcon from "../../static/assets/dashboard-sorting-variation.svg";
import DashboardSortingErrorChart from "./DashboardSortingErrorChart";
import {
  formatRate,
  formatVariation,
  readBooleanStorage,
  writeBooleanStorage,
} from "./dashboardKpiUtils";

const STORAGE_KEY = "dashboard.sortingErrorsOpen";
const STATISTICS_QUALITY_STATE = {
  activateCollectionField: false,
  activateQualityField: true,
  activateCostField: false,
  activateCarbonField: false,
};

export const DashboardSortingErrors = ({
  currentCount,
  previousCount,
  dataResult,
  collectionDataResult,
  statsReady,
  showPreviousComparison = false,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(() =>
    readBooleanStorage(STORAGE_KEY, true),
  );

  const toggleOpen = () => {
    setIsOpen((current) => {
      const next = !current;
      writeBooleanStorage(STORAGE_KEY, next);
      return next;
    });
  };

  return (
    <section className="dashboard-sorting-errors">
      <div className={`dashboard-sorting-header${isOpen ? " is-open" : ""}`}>
        <button
          type="button"
          className="dashboard-sorting-toggle"
          onClick={toggleOpen}
          aria-expanded={isOpen}
          aria-controls="dashboard-sorting-errors-panel"
        >
          <h3 className="dashboard-campaigns-title">
            {t("dashboard.sortingErrors")}
          </h3>
          <i
            className={`fas fa-chevron-down dashboard-sorting-chevron${isOpen ? " is-open" : ""}`}
            aria-hidden="true"
          />
        </button>
        <PillButton
          size="md"
          onClick={() =>
            history.push({
              pathname: "/statistics",
              state: STATISTICS_QUALITY_STATE,
            })
          }
        >
          {t("dashboard.viewSortingErrorsDetails")}
        </PillButton>
      </div>
      {isOpen ? (
        <div
          id="dashboard-sorting-errors-panel"
          className="dashboard-kpi-panel"
        >
          <div className="dashboard-volume-row">
            <HighlightCard
              iconSrc={sortingErrorIcon}
              title={t("dashboard.sortingErrors")}
              hint={t("dashboard.sortingErrorsHint")}
              value={formatRate(currentCount)}
            />
            {showPreviousComparison ? (
              <>
                <HighlightCard
                  iconSrc={sortingPreviousIcon}
                  title={t("dashboard.sortingErrorsPrevious")}
                  hint={t("dashboard.sortingErrorsPreviousHint")}
                  value={formatRate(previousCount)}
                />
                <HighlightCard
                  iconSrc={sortingVariationIcon}
                  title={t("dashboard.sortingErrorsVariation")}
                  hint={t("dashboard.sortingErrorsVariationHint")}
                  value={formatVariation(currentCount, previousCount)}
                />
              </>
            ) : null}
          </div>
          {statsReady ? (
            <DashboardSortingErrorChart
              dataResult={dataResult}
              collectionDataResult={collectionDataResult}
            />
          ) : null}
        </div>
      ) : null}
    </section>
  );
};
